import { inspectRequestService } from "../services/inspectRequest.service";
import { inspectRequestConstants } from "../constants/inspectRequest.constants";

export const inspectRequestActions = {
  get,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    inspectRequestService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return { type: inspectRequestConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(paginatedResult) {
    return { type: inspectRequestConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: inspectRequestConstants.GET_FAILURE };
  }
}
